import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AppProviders } from "@/app/providers";
import { AppRouter } from "@/app/router";
import { captureInstallPrompt } from "@/features/pwa/hooks";
import { registerServiceWorker } from "@/features/pwa/registerServiceWorker";
import "./styles.css";

const container = document.getElementById("root");
if (!container) throw new Error("Elemento #root nao encontrado no index.html");

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </StrictMode>,
);

captureInstallPrompt();
registerServiceWorker();
